$("[data-scroll-to-picker]").click(function () {
  scrollToEl(".main-product")
})

$('.main-product__read-more').click(function () {
  $('.main-product__description').toggleClass('reading-more');
  $('.main-product__read-more').toggleClass('reading-more');
}
)

const productDetailHeadings = $('.main-product__details-headings > *');
const productDetailContents = $('.main-product__details-content > *');

productDetailHeadings.click(function () {
  const detail = $(this).data('detail');
  productDetailHeadings.removeClass('detail-open');
  $(this).addClass('detail-open');
  productDetailContents.removeClass('detail-open');
  $('.main-product__details-content').find(`[data-detail='${detail}']`).addClass('detail-open');
})

const deliveryTimeText = $('.delivery-time-text');
if (deliveryTimeText.length > 0) {
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  //calculate date for weeks in future
  const now = new Date();
  now.setDate(now.getDate() + 21);
  const day = now.getDate();
  const month = monthNames[now.getMonth()];
  deliveryTimeText.text("Ships by " + month + " " + now.getDate())
}

if ($('.in-four-days').length > 0) {
  setDateInFourDays()
}
function setDateInFourDays() {
  // Calculate the new date
  var futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 4); // Four days from now

  // Create a string for the date
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  var dayName = days[futureDate.getDay()];
  var monthName = months[futureDate.getMonth()];
  var dateNumber = futureDate.getDate();

  var fullDateString = dayName + ', ' + monthName + ' ' + dateNumber;

  // Apply the date string to each element with the 'in-four-days' class
  $('.in-four-days').text(fullDateString);
}

if (document.querySelector(".main-product__countdown")) { startCountdown() }
function startCountdown() {
  var countDownDate = new Date().getTime() + (3 * 60 * 60 * 1000);
  var x = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    document.querySelector(".main-product__countdown").innerHTML = hours + " hours " + minutes + " minutes ";
    if (distance < 0) {
      clearInterval(x);
      document.querySelector(".main-product__countdown").innerHTML = "EXPIRED";
    }
  }, 1000);
}

// ---- Global Affirm refresh helper (simple debounce, no throttle) ----
window.scheduleAffirmRefresh = (function () {
  let timeoutId = null;

  return function scheduleAffirmRefresh(origin = 'unknown') {
    // console.log('[Affirm] scheduleAffirmRefresh from:', origin);

    if (!window.affirm || !affirm.ui || typeof affirm.ui.refresh !== 'function') {
      console.log('[Affirm] affirm.ui.refresh not ready yet');
      return;
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      // console.log('[Affirm] >>> calling affirm.ui.refresh() origin:', origin);
      try {
        affirm.ui.refresh();
      } catch (e) {
        console.warn('[Affirm] refresh failed:', e);
      }
    }, 50); // tiny debounce so bursts merge into one call
  };
})();



VariantHandling = {
  _initialise() {
    if ($('[data-product-json]').length == 0) return;
    this.product = JSON.parse($('[data-product-json]').text());
    this.variant = this._getVariantFromOptions();
    VariantHandling._handleChange.bind(this);
    this._handleChange();
    this._setAffirm(this.variant);
  },

  _handleChange() {
    const handlingObject = this;
    updateOptionBoxHeading();
    this._setHighestSize();
    handlingObject._updateMetafields();
    $(document).on("change", "[data-single-option-selector]", function (event) {
      handlingObject.variant = VariantHandling._getVariantFromOptions();
      handlingObject._updatePrice();
      handlingObject._updateMasterVariantID();
      updateOptionBoxHeading();
      handlingObject._updateATCText();
      // handlingObject._updateImages();
      handlingObject._updateMetafields();
      handlingObject._updateURL();
      handlingObject._setAffirm(handlingObject.variant);
    });
  },

  _updateURL() {
    if (!this.variant) return;
    window.history.replaceState({}, '', `${document.querySelector(".main-product").dataset.url}?variant=${this.variant.id}`);
  },

  _setAffirm(variant) {
    try {
      $('.main-product .affirm-as-low-as').attr('data-amount', variant.price);
      if (window.scheduleAffirmRefresh) {
        window.scheduleAffirmRefresh('VariantHandling._setAffirm');
      }
    } catch (err) {
      console.log(err);
    }
  },

  _setHighestSize() {
    let highestSize = -1;
    this.product.variants.forEach(variant => {
      variant.options.forEach(option => {
        if (!/\d/.test(option)) return;
        const optionSize = Number(option.replace('\"', ""));
        if (optionSize > highestSize) {
          highestSize = optionSize;
        }
      })
    })
    this.highestSize = highestSize;
  },

  _updateMetafields() {
    const size = this.variant.options.find(option => option.includes("\""));
    try {
      if (this.highestSize < 0) return;
      const currentSize = Number(this.variant.options.find(option => /\d/.test(option))?.replace('\"', ""));
      const metafieldsToChange = ["weight", "total_diamond_weight", "weight_per_inch"];
      metafieldsToChange.forEach((metafield, index) => {
        const currentMetafield = $(".product-metafield-info").find(`[data-metafield-type='${metafield}']`);
        if (currentMetafield.length == 0) return;
        const originalMetafieldValue = Number(currentMetafield.data("metafield-value"));
        if (isNaN(originalMetafieldValue)) return;
        let metafieldEnding = "g";
        if (index == 1) metafieldEnding = " ctw";
        currentMetafield.text(((originalMetafieldValue / this.highestSize) * currentSize).toFixed(1).toString() + metafieldEnding);
      })
    } catch (error) {
      console.log(error)
    }
  },

  _updateImages() {
    if (!document.querySelector("[data-are-glasses=true]")) return;
    const alt = this.variant.featured_media.alt;
    const options = this.variant.options.toString().toLowerCase().replaceAll(" ", "").replaceAll("&", "");
    const colourOptions = ["burgundyclear", "burgundyblack", "navyclear", "navy", "black"];
    let chosenOption;
    colourOptions.forEach(option => {
      if (!chosenOption && options.includes(option)) chosenOption = option;
    })
    if (chosenOption) {
      const desktopImageWrappers = document.querySelectorAll('.main-product__desk-imgs .main-product__img-wrapper');
      desktopImageWrappers.forEach(imgWrapper => {
        const imgAlt = imgWrapper.querySelector('img').getAttribute("alt");
        if (imgAlt) {
          const formattedImgAlt = imgAlt.toLowerCase().replaceAll(" ", "").replaceAll("&", "");
          imgWrapper.classList.toggle("hidden", !formattedImgAlt.includes(chosenOption))
        }
      })

      //mobile carousel hiding/showing
      document.querySelector(".main-product__imgs").querySelectorAll(".splide-wrapper").forEach(wrapper => wrapper.classList.add("hidden"));
      document.querySelector('.splide-wrapper[data-color="' + chosenOption + '"]').classList.remove("hidden")
    }
  },

  _updateATCText() {
    if (this.variant.available) {
      $('[data-add-to-cart-text]').text(Shopify.strings.addToCart);
      $('[data-add-to-cart]').removeAttr('disabled');
    }
    else {
      $('[data-add-to-cart-text]').text(Shopify.strings.unavailable);
      $('[data-add-to-cart]').attr('disabled', '');
    }
  },

  _updateMasterVariantID() {
    $('[data-product-select]').val(this.variant.id);
  },

  _updatePrice() {
    const isDiscounted = this.variant.compare_at_price > this.variant.price;
    $(".main-product .theme-money").toggleClass("product-price__compare", isDiscounted)
    $(".reduced-price").toggleClass("product-price__reduced", isDiscounted)

    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-compare-price]');

    if (priceEl && priceEl.hasAttribute('data-ice-money-cents')) {
      priceEl.setAttribute('data-ice-money-cents', String(this.variant.price));
    }
    if (compareEl && compareEl.hasAttribute('data-ice-money-cents')) {
      if (isDiscounted) {
        compareEl.setAttribute('data-ice-money-cents', String(this.variant.compare_at_price));
        compareEl.removeAttribute('data-ice-hide-if-zero');
      } else {
        compareEl.setAttribute('data-ice-money-cents', '0');
        compareEl.setAttribute('data-ice-hide-if-zero', '');
      }
    }

    var saveWrap = document.querySelector('.price_and_save .save_texts');
    var discountEl = document.querySelector('.price_and_save .discount');
    if (saveWrap) saveWrap.hidden = !isDiscounted;
    if (discountEl && discountEl.hasAttribute('data-ice-money-cents')) {
      if (isDiscounted) {
        var displayMode = saveWrap ? saveWrap.getAttribute('data-display-mode') : null;
        var rawDiscountCents = this.variant.compare_at_price - this.variant.price;

        if (displayMode === 'percent') {
          // Percent mode: text is "X% off", not a money value — leave cents
          // attribute alone (it isn't used for percent display) but still
          // round the visible percent text so it matches the badge's rounding.
          var rawPercent = (rawDiscountCents * 100) / this.variant.compare_at_price;
          var roundedPercent = Math.round(rawPercent / 5) * 5;
          if (discountEl) discountEl.textContent = roundedPercent;
        } else {
          // Amount mode: round to nearest $5 (500 cents) before writing,
          // so downstream formatters (Shopify.formatMoney / iceCurrencyApplyPrices)
          // never see the raw, unrounded value in the first place.
          var roundedDollars = Math.round((rawDiscountCents / 100) / 5) * 5;
          var roundedCents = roundedDollars * 100;
          discountEl.setAttribute('data-ice-money-cents', String(roundedCents));
        }
      }
    }

    if (typeof window.iceCurrencyApplyPrices === 'function') {
      window.iceCurrencyApplyPrices();
    } else {
      if (isDiscounted) $('[data-compare-price]').text(`${Shopify.formatMoney(this.variant.compare_at_price, Shopify.money_format)}`);
      $('[data-product-price]').text(`${Shopify.formatMoney(this.variant.price, Shopify.money_format)}`);
      if (isDiscounted && discountEl && discountEl.hasAttribute('data-ice-money-cents')) {
        var savedCents = parseInt(discountEl.getAttribute('data-ice-money-cents'), 10);
        if (!isNaN(savedCents)) {
          discountEl.textContent = Shopify.formatMoney(savedCents, Shopify.money_format).replace(/([.,])00(?!\d)/, '');
        }
      }
    }
  },

  _getVariantFromOptions() {
    var selectedValues = this._getCurrentOptions();
    var variants = this.product.variants;
    var found = false;

    variants.forEach(function (variant) {
      var satisfied = true;

      selectedValues.forEach(function (option) {
        if (satisfied) {
          satisfied = option.value === variant[option.index];
        }
      });

      if (satisfied) {
        found = variant;
      }
    });

    return found || null;
  },

  _getCurrentOptions: function _getCurrentOptions() {
    var currentOptions = $.map($('[data-single-option-selector]', '.main-product'), function (element) {
      var currentOption = {};

      var selectedOption = element.querySelector('input:checked');

      if (selectedOption) {
        currentOption.value = selectedOption.value;
        currentOption.index = element.dataset.index;

        return currentOption;
      } else {
        return false;
      }
    });

    return currentOptions;
  },
}
VariantHandling._initialise();

function updateOptionBoxHeading() {
  var $btns = $('[data-update-heading-box]');

  $btns.each(function () {
    var $fieldset = $(this);
    var $label = $fieldset.find('.js-option-title');
    if (!$label.length) return;

    const changeHeadingHTML = this.dataset.headingSwatch !== undefined;
    var $checkedInput = $fieldset.find('.opt-btn:checked');
    if (!$checkedInput.length) return;

    if (changeHeadingHTML) {
      // COLOR SWATCH MODE (has data-heading-swatch)
      var $checkedLabel = $checkedInput.next('.opt-label');
      if (!$checkedLabel.length) return;

      var colorName =
        $checkedLabel.data('label') || $checkedLabel.text().trim();
      var swatchHTML =
        $checkedLabel.find('.custom-swatch').prop('outerHTML') || '';

      var headingHTML = swatchHTML + ' ' + colorName;
      $label.html(headingHTML);
      $label.data('default-content', headingHTML);
    } else {
      // NORMAL OPTIONS (size, length, etc.)
      var value = $checkedInput.val();
      $label.text(value);
      $label.data('default-content', value);
    }
  });
}


function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

waitForElm('#dummy-chat-button-iframe').then((elm) => {
  const floatingATC2 = document.querySelector('.floating-atc');
  if (floatingATC2 && floatingATC2.classList.contains('show')) {
    elm.classList.add('move-chat')
  }
});

class TOC extends HTMLElement {
  constructor() {
    super();

    this.tocLinkWrapper = this.querySelector('.toc__links');
    this._setupA11y();
    this._setup();
    this.currentlyHighlighted = -1;
    this.highlightedHeading = -1;
    this._highlightTOC();
    window.onscroll = () => this._highlightTOC();
  }

  _setupA11y() {
    // Add navigation role and label to the custom element
    this.setAttribute('role', 'navigation');
    this.setAttribute('aria-label', 'Table of contents');

    // Add aria-hidden to icons
    const icons = this.querySelectorAll('.toc__icon');
    icons.forEach(icon => icon.setAttribute('aria-hidden', 'true'));

    // Make the toggle div act as a button
    const toggleWrapper = this.querySelector('.only-mobile');
    if (toggleWrapper) {
      toggleWrapper.setAttribute('role', 'button');
      toggleWrapper.setAttribute('tabindex', '0');
      toggleWrapper.setAttribute('aria-expanded', 'false');
      toggleWrapper.setAttribute('aria-label', 'Toggle table of contents');

      // Add keyboard support for Enter and Space
      toggleWrapper.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleWrapper.click();
        }
      });
    }

    // Add list role to toc__links
    if (this.tocLinkWrapper) {
      this.tocLinkWrapper.setAttribute('role', 'list');
    }
  }

  _setup() {
    const headers = $('.blog-content h2, .blog-content h1');
    const wrapper = $(this.tocLinkWrapper);
    headers.each(function (index) {
      $(this).attr("toc-index", index);
      wrapper.append(
        `
          <div role="listitem"><div class="toc__link" role="link" tabindex="0">
            ${this.innerText.toLowerCase()}
          </div></div>
        `
      )
    });

    const $header = $('#headerSection');
    this.tocLinks = $(this.querySelectorAll('.toc__link'));
    const tocLinks = this.tocLinks;
    const mainTOC = this;

    // Click and keyboard handler for TOC links
    $(tocLinks).on('click keydown', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (e.type === 'keydown') e.preventDefault();

      const headingIndex = tocLinks.index(this);
      const $headingToScrollTo = $(`[toc-index='${headingIndex}']`);
      window.scrollTo(0, $headingToScrollTo.offset().top - 100);
      $header.addClass('sticky-header-hidden');
      setTimeout(() => {
        $headingToScrollTo.addClass('highlighted');
        mainTOC.highlightedHeading = headingIndex;
      }, 10);
    });

    const $toc = $(this);
    const toggleWrapper = this.querySelector('.only-mobile');
    $(toggleWrapper).click(function () {
      const isOpen = $toc.toggleClass('open').hasClass('open');
      $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  _highlightTOC() {
    let tocToHighlight = 0;
    const tocLinks = this.tocLinks;
    tocLinks.each(function () {
      const headingIndex = tocLinks.index(this);
      const top = $(`[toc-index='${headingIndex}']`)[0].getBoundingClientRect().top;
      if (top < 150) {
        tocToHighlight = headingIndex;
      }
      else {
        return false;
      }
    })

    if (this.highlightedHeading != null) {
      $(`[toc-index]`).removeClass('highlighted');
    }

    if (this.currentlyHighlighted != tocToHighlight) {
      this.currentlyHighlighted = tocToHighlight;
      tocLinks.removeClass('active');
      tocLinks.attr('aria-current', 'false');
      $(tocLinks[tocToHighlight]).addClass('active');
      $(tocLinks[tocToHighlight]).attr('aria-current', 'true');
    }
  }
}

customElements.define("blog-toc", TOC);

//Review Section Popup
$('.review-card, .testimonial-card').click(function () {
  $('.review__popup-wrapper').removeClass('hidden');
  const cloned = this.cloneNode(true);
  $('.review__popup-item').html(cloned);
})

$('.review__popup-bg, .review__popup-close').click(function () {
  $('.review__popup-wrapper').addClass('hidden');
});

//Review Section Load Buttons
const $loadDesk = $('.reviews__load .load-btn');
if ($loadDesk.length > 0) {
  const $reviewsGrid = $('.reviews-grid');
  const $reviewsCols = $('.reviews-col');
  checkLoadDesk();
  $loadDesk.click(function () {
    const oldHeight = $reviewsGrid.height() + "px";
    $reviewsGrid.css("height", "calc(" + oldHeight + " + 100vh)");
    checkLoadDesk();
  })

  function checkLoadDesk() {
    const loadMoreBottom = $loadDesk.get(0).getBoundingClientRect().bottom;
    let lowest = -1;

    $('.reviews-col').each(function () {
      const bottom = this.getBoundingClientRect().bottom;
      if (bottom > lowest) {
        lowest = bottom;
      }
    })

    if (loadMoreBottom > lowest) {
      $reviewsGrid.css("height", "auto");
      $('.reviews__load').addClass('hidden');
    }
  }
}

const $loadMob = $('.reviews__load-mobile .reviews__load-btn');
if ($loadMob.length > 0) {
  const $mobileCol = $('.reviews-col__mobile');
  checkLoadMob();
  $loadMob.click(function () {
    const oldHeight = $mobileCol.height() + "px";
    $mobileCol.css("height", "calc(" + oldHeight + " + 100vh)");
    checkLoadMob();
  })
  function checkLoadMob() {
    const loadMoreBottom = $('.reviews__load-mobile .reviews__load-btn').get(0).getBoundingClientRect().bottom;
    const lowest = $('.reviews-col__mobile .review-card').last().get(0).getBoundingClientRect().bottom;

    if (loadMoreBottom > lowest) {
      $('.reviews-col__mobile').css("height", "auto");
      $('.reviews__load-mobile').addClass('hidden');
    }
  }
}

/* CUSTOM FORM CODE */
waitForElm('.custom-product__form select').then((elm) => {
  const customProductForm = $('.custom-product__form');
  const customProductFormContent = $('.custom-product__content')
  $('.custom-product__heading').click(() => {
    if (customProductForm.hasClass('open')) {
      customProductFormContent.slideUp();
    }
    else {
      customProductFormContent.slideDown();
    }
    customProductForm.toggleClass('open');
  })

  const customFormRequired = $('.custom-product__form select');

  $('.custom-form__submit').click(e => {
    if ($(".custom-product__form").hasClass("open")) {
      $('.gfb__footer .submit').click();
    } else {
      customProductFormContent.slideDown();
      customProductForm.addClass('open');
    }
  })

  const fileBtn = $('.custom-product__file-btn');
  const fileInput = $('.custom-product__file');
  const fileText = $('.custom-product__selected-file');
  fileBtn.click(function () {
    fileInput.click();
  });

  fileInput.change(function () {
    var fileName = $(this).val().split('\\').pop();
    fileText.text(fileName)
  });
});

waitForElm(".yv_side_drawer_body .affirm-as-low-as").then(elm => {
  const affirmEl = elm;
  $(".bottom-cart-box .list-unstyled").append(affirmEl);
  const targetElement = document.querySelector('.yv-side-drawer-container');

  let lastSideDrawerAmount = null;

  const mutationCallback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const newAmount = $(".bottom-cart-box .totle-price .h4").text().replace(/[^0-9]/g, '');

        if (!newAmount) return;

        // Only react if amount actually changed
        if (newAmount === lastSideDrawerAmount) {
          return;
        }
        lastSideDrawerAmount = newAmount;

        affirmEl.dataset.amount = newAmount;
        $(".bottom-cart-box .list-unstyled").append(affirmEl);

        if (window.scheduleAffirmRefresh) {
          window.scheduleAffirmRefresh('side-drawer-mutation');
        } else if (window.affirm?.ui?.refresh) {
          affirm.ui.refresh();
        }
      }
    }
  };

  const observer = new MutationObserver(mutationCallback);
  const config = { childList: true, subtree: true };
  observer.observe(targetElement, config);
});

const sizeChartPopup = document.querySelector("[data-pdp-size-chart-target]");
$(".main-product__size-charts").click(function () {
  sizeChartPopup.classList.remove("hidden");
});

$(document).on("click", "[data-size-chart-trigger]", function () {
  $("[data-size-chart-target]").removeClass("hidden");
  $("[data-size-chart-target]").html(
    $(this).siblings(".size-chart__popup").html()
  );
});

$(document).on("click", ".size-chart__close", function () {
  this.closest(".size-chart__popup").classList.add("hidden");
  sizeChartPopup.classList.add("hidden");
});

$(".loox-rating").click(() => scrollToEl("#looxReviews"))

$(".floating-atc").click(e => {
  const product = JSON.parse($('[data-product-json]').text());
  if (product.variants[0].id == $(".floating-atc").find("[data-product-select]").val()) {
    e.preventDefault();
    e.stopPropagation();
    scrollToEl(".main-product")
  }
})

function scrollToEl(selector) {
  var elementPosition = document.querySelector(selector).getBoundingClientRect().top + window.scrollY;
  const headerHeight = document.querySelector("header").getBoundingClientRect().height;
  window.scrollTo({
    top: elementPosition - headerHeight,
    behavior: 'smooth'
  });
}

document.querySelectorAll('video:not(.banner-video)').forEach(video => {
  // ❌ Skip videos inside a .banner element
  if (video.closest('.banner')) return;

  // ✅ Add play/pause class toggles
  video.addEventListener('play', () => video.classList.add("playing"));
  video.addEventListener('pause', () => video.classList.remove("playing"));

  // ✅ Toggle playback when the video itself is clicked
  video.addEventListener('click', e => {
    e.preventDefault();
    video.classList.contains("playing") ? video.pause() : video.play();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll('.banner-video');

  videos.forEach((video) => {
    video.play();

    // Ensure the video never pauses
    video.addEventListener('pause', () => {
      video.play();
    });
  });
});

var productMediaModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: (function () {

          document.querySelectorAll('.yv-product-model-item').forEach((model) => {
            let model3D = model.querySelector('model-viewer')
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', function (evt) {
              model.querySelectorAll('.close-product-model').forEach(el => {
                el.classList.remove('hidden');
              });
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            }.bind(this));

            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', function (evt) {
              model.querySelectorAll('.close-product-model').forEach(el => {
                el.classList.add('hidden');
              });
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            }.bind(this));

            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', function () {
                if (model3D) {
                  model.modelViewerUI.pause();
                }
              }.bind(this))
            });

          });

        })
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (!errors) {
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }
      document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
        window.ShopifyXR.addModels(JSON.parse(model.textContent));
      });
      window.ShopifyXR.setupXRElements();
    }
  },
};

window.addEventListener('DOMContentLoaded', () => {
  let productModel = document.querySelectorAll('[id^="product3DModel-"]');
  if (productMediaModel && productModel.length > 0) {
    productMediaModel.loadShopifyXR();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  //listen for mouse enter .dropdown-menu-list and show child details
  document.querySelectorAll('.dropdown-menu-list').forEach((el) => {
    el.addEventListener('mouseenter', () => {
      el.querySelector('details').setAttribute('open', '');
      el.querySelector('details').classList.add('open');
    });

    el.addEventListener('mouseleave', () => {
      el.querySelector('details').removeAttribute('open');
      el.querySelector('details').classList.remove('open');
    });
  });
});

// NOTE: cart drawer + free gift logic moved to cart-drawer-logic.js and cart-gifts.js

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.setAvailable(false);
    } else {
      this.setAvailable(true);
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const input =
      this.closest("product-form").querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const priceContainer = this.closest("product-form").querySelector("[data-product-prices]");
    if (!priceContainer) return;

    if (priceContainer.closest("cart-drawer")) {
      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&view=cart-drawer-recommendation`
      )
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariant.id !== requestedVariantId) return;
          const html = new DOMParser().parseFromString(responseText, "text/html");
          priceContainer.innerHTML = html.querySelector("[data-product-prices]").innerHTML;
          if (typeof window.iceCurrencyApplyPrices === 'function') window.iceCurrencyApplyPrices();
        })
    }
  }

  setAvailable(value) {
    this.closest("product-form").querySelector("[type='submit']").disabled =
      !value;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

document.addEventListener("rebuy:smartcart.ready", () => {
  Rebuy.SmartCart.destroy();
});

document.querySelectorAll(".collection-grid-payments").forEach((element) =>
  new Splide(element, {
    perPage: 1,
    perMove: 1,
    arrows: false,
  }).mount()
);

document.querySelectorAll(".testimonial-slider").forEach((element) =>
  new Splide(element, {
    perPage: 6,
    perMove: 2,
    pagination: false,
    gap: 20,
    breakpoints: {
      1440: {
        perPage: 4
      },
      640: {
        perPage: 1,
        autoWidth: true,
        drag: "free"
      },
    }
  }).mount()
);

document.querySelectorAll(".collection-highlight-slider").forEach((element) =>
  new Splide(element, {
    perPage: Number(element.dataset.slides) + 1,
    perMove: 2,
    pagination: false,
    gap: 20,
    breakpoints: {
      1500: {
        perPage: element.dataset.slides
      },
      640: {
        perPage: 1,
        autoWidth: true,
        drag: "free",
        gap: 8
      },
    }
  }).mount()
);

// document.querySelectorAll(".collection-grid-slider").forEach((element) =>
//   new Splide(element, {
//     perPage: 6,
//     perMove: 2,
//     pagination: false,
//     gap: 20,
//     breakpoints: {
//       640: {
//         perPage: 2,
//         gap: 8,
//         drag: "free"
//       },
//     }
//   }).mount()
// );

document.querySelectorAll(".youtube-card-slider").forEach((element) =>
  new Splide(element, {
    perPage: 3,
    pagination: false,
    gap: 20,
    breakpoints: {
      640: {
        perPage: 1,
        drag: "free"
      },
    }
  }).mount()
);

document.querySelectorAll(".categories-slider").forEach((element) =>
  new Splide(element, {
    pagination: false,
    arrows: true,
    gap: 8,
    drag: "free",
    autoWidth: true
  }).mount()
);

document.body.addEventListener('click', function (event) {
  if (event.target.closest('.open-customform')) {
    event.preventDefault(); // Prevent default link behavior
    document.getElementById('popup-overlay').style.display = 'block';
    document.getElementById('popup-content').style.display = 'flex';
    document.getElementsByTagName("body")[0].style.overflow = 'hidden';
  }
});

jQuery(document).ready(function ($) {
  if ($(".btn_add_to_cart_test").length > 0) {
    $(document).on("click", ".btn_add_to_cart_test", function () {
      $('.payment-buttons .main-product__atc').trigger('click');
    });
  }
});

const guaranteePopup = document.querySelector("[data-pdp-guarantee-target]");
$(".main-product__guarantee").click((function () {
  guaranteePopup.classList.remove("hidden")
})), $(document).on("click", ".guarantee-popup__close", (function () {
  this.closest(".guarantee-popup").classList.add("hidden"), guaranteePopup.classList.add("hidden")
}));

$(document).ready(function () {
  $(document).on("click", ".option-selector__btns .opt-label", function () {
    setTimeout(function () {
      if (typeof window.iceCurrencyApplyPrices === 'function') window.iceCurrencyApplyPrices();
    }, 300);
  });

  var shopify_responsive_current_width = window.innerWidth;
  var shopify_responsive_min_width = 1001;
  var shopify_responsive_mobile = shopify_responsive_current_width < shopify_responsive_min_width;

  if (shopify_responsive_mobile) {
    convertToMobile();
  }

  if ($("#_desktop_reviewwidget").length > 0) {
    $(window).on('resize', function () {
      var _mw = shopify_responsive_min_width;
      var _w = window.innerWidth;
      var desktopContent = $("*[id^='_desktop_']").first().html().trim().length;
      var mobileContent = $("*[id^='_mobile_']").first().html().trim().length;
      if (_w < _mw && desktopContent) {
        convertToMobile();
      }
      if (_w >= _mw && mobileContent) {
        convertToDesktop();
      }
    });
  }

});

function convertToMobile() {

  $("*[id^='_desktop_']").each(function (index, element) {
    var target = $('#' + element.id.replace('_desktop_', '_mobile_'));
    swapElements($(this), target);
  });
}
function convertToDesktop() {
  //interchange sections
  $("*[id^='_mobile_']").each(function (index, element) {
    var target = $('#' + element.id.replace('_mobile_', '_desktop_'));
    swapElements($(this), target);
  });
}

function swapElements(source, destination) {
  var temp = destination.children().detach();
  destination.empty().append(source.children().detach());
  source.append(temp);
}

